module.exports = __webpack_public_path__ + "img/bg-store.70954743.png";